import { Mixin } from 'mixwith';
import { ElementNodeBuilder } from 'Editor/services/Model';
import { ELEMENTS } from 'Editor/services/consts';

export default Mixin(
  (superclass) =>
    class extends superclass {
       
      parseCrossReference(representation) {
        const builder = new ElementNodeBuilder();
        builder.addElementType(ELEMENTS.CrossReferenceElement.ELEMENT_TYPE);
        if (representation.attributes.parent_id) {
          builder.addParentId(representation.attributes.parent_id.nodeValue);
        }
        if (representation.attributes.id) {
          builder.addId(representation.attributes.id.nodeValue);
        }
        if (representation.attributes.target) {
          builder.addProperty('target', representation.attributes.target.nodeValue);
        }
        return builder.getNode();
      }
    },
);
